package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2025_03_15_Day_1
import com.veldekar.components.logs.Log_2025_03_15_Day_2
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2025-03-15")
@Composable
public fun Log_2025_03_15(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Democracy in Bondōvriar",
        ogTitle = "Democracy in Bondōvriar",
        date = LocalDate(2_025, 3, 15),
        aiHint = "Description is a reference to Monty Python's Search for the Holy Grail",
        ogDescription = "I didn’t know we had a king. I thought we were an autonomous collective.",
        ogImage = "ai/2025-03-15.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-78", dateString = "Newgrowth 78")
        Log_2025_03_15_Day_1()
        SessionDayHeader(dayId = "newgrowth-79", dateString = "Newgrowth 79")
        Log_2025_03_15_Day_2()
    }
}
